import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import useAsyncSearchAutoritefourriere from 'hooks/search/async/useAsyncSearchAutoritefourriere';
import useAsyncSearchFourriere from 'hooks/search/async/useAsyncSearchFourriere';
import useAsyncSearchAdminUniteFo from 'hooks/search/async/useAsyncSearchUniteFo';
import { SearchResult } from 'types/searchResult';
import { ShouldNotHappen } from 'utils/exceptions';

export default function useUniteRattachement(
  selectedProfile: UserDtoProfileEnum | undefined,
) {
  function useEmptySearch(_?: string): SearchResult {
    return {
      result: [],
    };
  }

  switch (selectedProfile) {
    case UserDtoProfileEnum.GARDIEN_FOURRIERE:
      return useAsyncSearchFourriere;
    case UserDtoProfileEnum.AUTORITE_FOURRIERE:
      return useAsyncSearchAutoritefourriere;
    case UserDtoProfileEnum.FORCE_DE_L_ORDRE:
      return useAsyncSearchAdminUniteFo;

    case undefined:
    case UserDtoProfileEnum.CSU:
    case UserDtoProfileEnum.DSR_BLR:
    case UserDtoProfileEnum.ADMIN_FONCTIONNEL:
    // TODO: MINTF-5843 : Implémenter le hook pour récupérer les juridictions
    case UserDtoProfileEnum.TRIBUNAL_JUDICIAIRE:
    case UserDtoProfileEnum.COUR_APPEL:
    case UserDtoProfileEnum.UNITE_OPERATIONNELLE:
    case UserDtoProfileEnum.NATIONAL_JUSTICE:
      return useEmptySearch;

    default:
      throw new ShouldNotHappen(selectedProfile);
  }
}
